<template>
<div class="chapter">
<div class="inner_page">
<p class="htit"><a id="page_i"></a><span class="bold">Free People, Free Markets</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_halftitle.vue?7e78f628